module.exports = __webpack_public_path__ + "img/am-login-bg.f74aee17.png";